import { render, staticRenderFns } from "./ArrowPagination.vue?vue&type=template&id=6ba8f46f&"
import script from "./ArrowPagination.vue?vue&type=script&lang=js&"
export * from "./ArrowPagination.vue?vue&type=script&lang=js&"
import style0 from "./ArrowPagination.vue?vue&type=style&index=0&id=6ba8f46f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports